export default __webpack_public_path__ + "static/iam_role_01-5ca1c0c9e6d3f6fbaf284699b9b0f049.png";